const ALLOW_FROM_URLS: string[] = ['/login/prepare', '/login/username_password',  '/login/totp', 'sms_otp', 'email_otp', 'security_key']
const ALLOW_TO_URLS: string[] = ['/main/connection']

export default {ALLOW_FROM_URLS, ALLOW_TO_URLS};
